import terminatorErrorMessage from './terminatorErrorMessage'
import { useParams, useNavigate } from 'react-router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getSeasons, getMainPageData, getNflScoreboard } from '@severed-links/common.redherrings-reducers/terminator'
import { Alert, Button, Form } from 'react-bootstrap'
import NFLScoreboardGameDay from '../Football/RegularSeason/NFL/NFLScoreboardGameDay'
import * as s from '../Football/RegularSeason/NFL/NFLScoreboard.scss'

const TerminatorNflScoreboard = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const navigate = useNavigate()
  const { seasons, seasonId: activeSeason, nflScoreboards, seasonMode, week: currentWeek, playoffWeek } = useSelector(state => state.terminator)
  const weekKey = params.playoffWeek ? `PW${params.playoffWeek}` : params.week ? `W${params.week}` : seasonMode === 'Postseason' ? `PW${playoffWeek || 1}` : `W${currentWeek || 1}`
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [refresh, setRefresh] = useState(0)
  const seasonId = params.seasonName ? seasons.find(item => item.seasonName === params.seasonName)?.seasonId : activeSeason
  const season = seasons.find(item => item.seasonId === seasonId)
  const isPlayoffWeek = weekKey.startsWith('PW')
  const week = Number(weekKey.replace(/^P?W/, ''))
  const scoreboardPath = (name, key) => `/terminator/nfl-scoreboard/${encodeURIComponent(name)}/${key.startsWith('PW') ? 'playoff-week' : 'week'}/${Number(key.replace(/^P?W/, ''))}`
  const setSelectedSeason = id => {
    const next = seasons.find(item => item.seasonId === id)
    if (next) navigate(scoreboardPath(next.seasonName, weekKey))
  }
  const setWeekKey = key => { if (season) navigate(scoreboardPath(season.seasonName, key)) }
  useEffect(() => {
    if (!params.seasonName && season) navigate(scoreboardPath(season.seasonName, weekKey), { replace: true })
  }, [params.seasonName, season, weekKey, navigate])
  const scoreboard = nflScoreboards.find(item => item.seasonId === seasonId && item.weekNumber === week && item.isPlayoffWeek === isPlayoffWeek)
  useEffect(() => {
    let active = true
    Promise.all([dispatch(getSeasons()).then(action => {
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
        return payload
      }), dispatch(getMainPageData()).then(action => {
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
        return payload
      })]).catch(error => { if (active) setError(terminatorErrorMessage(error)) })
    return () => { active = false }
  }, [dispatch, refresh])
  useEffect(() => {
    if (!seasonId) return
    let active = true
    setLoading(true)
    setError('')
    const loadScoreboard = async () => {
      try {
        const action = await dispatch(getNflScoreboard(seasonId, week, isPlayoffWeek))
        const payload = action?.payload
        if (action?.error || !payload || payload.messageType === 'error') throw new Error(payload?.response?.message || payload?.message || 'Unable to load Terminator. Please try again.')
      } catch (error) {
        if (active) setError(terminatorErrorMessage(error))
      }
      if (active) setLoading(false)
    }
    loadScoreboard()
    return () => { active = false }
  }, [dispatch, seasonId, week, isPlayoffWeek, refresh])
  return <main className={s.container + ' ' + s.eliminator}>
    <div className={s.hero}>
      <div className={s.heroBody}><div className={s.eyebrow}>Terminator</div><h2 className={s.title}>NFL Scoreboard</h2><div className={s.subtitle}>{season?.seasonName} · {isPlayoffWeek ? 'Playoff ' : ''}Week {week}</div></div>
      <div className={s.controls}>
        <Form.Select aria-label='Season' value={seasonId || ''} onChange={event => setSelectedSeason(event.target.value)}>
          {!seasons.length ? <option value=''>Loading seasons…</option> : null}
          {seasons.map(item => <option key={item.seasonId} value={item.seasonId}>{item.seasonName}</option>)}
        </Form.Select>
        <Form.Select aria-label='Week' value={weekKey} onChange={event => setWeekKey(event.target.value)}>
          {Array.from({ length: 18 }, (_, index) => <option key={`W${index + 1}`} value={`W${index + 1}`}>Week {index + 1}</option>)}
          {Array.from({ length: 4 }, (_, index) => <option key={`PW${index + 1}`} value={`PW${index + 1}`}>Playoff Week {index + 1}</option>)}
        </Form.Select>
      </div>
    </div>
    {error ? <Alert variant='danger'>{error} <Button onClick={() => setRefresh(value => value + 1)}>Retry</Button></Alert> : null}
    {loading ? <p role='status'>Loading scores…</p> : null}
    {!loading && scoreboard && !scoreboard.gameDays?.length ? <p>No games scheduled for this week.</p> : null}
    <div className={s.gamesContainer}>{scoreboard?.gameDays?.map(day =>
      <NFLScoreboardGameDay key={day.gameDate} gameDay={day} seasonId={scoreboard.seasonId} seasonName={scoreboard.seasonName} seasonMode={scoreboard.seasonMode} week={scoreboard.weekNumber} showLines={false} />)}</div>
  </main>
}
export default TerminatorNflScoreboard
